import { AtLeast } from '../UtilityTypes';
import { ArnCondition, ArnPredefinedConditionTemplate } from './ArnCondition';
import { ArnConditionOpts } from './ArnConditionOpts';

export interface IsWhitelistedConditionOpts extends ArnConditionOpts {
  /**
   * The list of public keys to scan.
   *
   * Should be provided on server side only.
   */
  whitelist: string[];
}

/**
 * WARNING: This condition is indicated as server defined only.
 * It means that only the 'name' property of 'ArnConditionOpts'
 * will be used by the server (when receiving a request from the client)
 * to fill the other properties with values that are stored server side
 */
export class IsWhitelistedCondition implements ArnCondition {
  readonly templateName = ArnPredefinedConditionTemplate.IsWhitelisted;

  constructor(public opts: AtLeast<IsWhitelistedConditionOpts, 'name'>) {}
}
